<app-header></app-header>

<div class="login-container">
  <!-- OTP Verification Component (shown after patient lookup succeeds) -->
  <app-otp-auth
    *ngIf="showOtpInput"
    [showOtpForm]="otpVerifyInProgress"
    [phoneNumber]="phoneNumberForOtp"
    (onOtpVerified)="onOtpVerified($event)"
    (onBack)="onOtpBack()">
  </app-otp-auth>

  <!-- Name Verification Form (shown when multiple patients found with same phone + DOB) -->
  <mat-card class="login-card" *ngIf="showNameVerification && !showOtpInput">
    <mat-card-header>
      <mat-card-title>
        <div class="clinic-info">
          <img [src]="getLogoUrl()"
               (error)="onImgError($event)"
               alt="Clinic Logo" class="clinic-logo">
          <span class="clinic-name">{{ appConfig.displayName }}</span>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="login-form">
      <mat-card-subtitle class="context-info">
        Verify Your Identity
      </mat-card-subtitle>
      <p class="verification-message">
        Multiple accounts found with this phone number and date of birth. Please enter your name to continue.
      </p>
      <form [formGroup]="nameVerificationForm" (ngSubmit)="verifyName()">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>First Name</mat-label>
          <mat-icon matPrefix>person</mat-icon>
          <input matInput formControlName="firstName" placeholder="Enter your first name">
          <mat-error *ngIf="nameVerificationForm.get('firstName')?.hasError('required')">First name is required</mat-error>
          <mat-error *ngIf="nameVerificationForm.get('firstName')?.hasError('minlength')">First name must be at least 2 characters</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Last Name</mat-label>
          <mat-icon matPrefix>person_outline</mat-icon>
          <input matInput formControlName="lastName" placeholder="Enter your last name">
          <mat-error *ngIf="nameVerificationForm.get('lastName')?.hasError('required')">Last name is required</mat-error>
          <mat-error *ngIf="nameVerificationForm.get('lastName')?.hasError('minlength')">Last name must be at least 2 characters</mat-error>
        </mat-form-field>
        <p class="error-message" *ngIf="nameVerificationError">{{ nameVerificationError }}</p>
        <div class="button-group">
          <button mat-stroked-button type="button" (click)="cancelNameVerification()">Back</button>
          <button mat-raised-button color="primary" type="submit" [disabled]="nameVerificationForm.invalid">
            Verify & Continue
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- Login Form (shown initially) -->
  <mat-card class="login-card" *ngIf="!showOtpInput && !isNewPatient && !showNameVerification">
    <mat-card-header>
      <mat-card-title>
        <div class="clinic-info">
          <img [src]="getLogoUrl()"
               (error)="onImgError($event)"
               alt="Clinic Logo" class="clinic-logo">
          <span class="clinic-name">{{ appConfig.displayName }}</span>
        </div>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="login-form">
      <mat-card-subtitle class="context-info">
        {{ getContextInfo() || 'Login to access your patient portal' }}
      </mat-card-subtitle>
      <form [formGroup]="authForm" (ngSubmit)="authenticate()">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Phone Number</mat-label>
          <mat-icon matPrefix>phone</mat-icon>
          <input matInput formControlName="phoneNumber" placeholder="Enter your phone number" type="tel" #phoneInput>
          <mat-error *ngIf="authForm.get('phoneNumber')?.hasError('pattern')">Invalid phone number format</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>Date of Birth</mat-label>
          <mat-icon matPrefix>calendar_today</mat-icon>
          <input matInput formControlName="dob" autoSlashDateFormat placeholder="MM/DD/YYYY" [matDatepicker]="picker" #dobInput>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="authForm.get('dob')?.hasError('required')">Date of birth is required</mat-error>
        </mat-form-field>
        <div class="remember-me-container">
          <mat-checkbox formControlName="rememberMe" color="primary">Remember Me</mat-checkbox>
          <mat-icon class="info-icon" (click)="showRememberMeInfo()">
            info_outline
          </mat-icon>
        </div>
        <button mat-raised-button color="primary" type="submit" [disabled]="requestInProgress || authForm.invalid">Login</button>
        <div class="signup-section">
          <span class="signup-text">New patient?</span>
          <button mat-stroked-button color="primary" type="button" (click)="navigateToSignup()">Sign Up</button>
        </div>
        <div class="clinic-view-section">
          <button mat-stroked-button type="button" (click)="navigateToKiosk()" class="clinic-view-btn">
            <mat-icon>tablet_mac</mat-icon>
            Clinic View
          </button>
        </div>
      </form>
      <div class="legal-links">
        <a routerLink="/privacy">Privacy Policy</a>
        <span class="divider">|</span>
        <a routerLink="/terms">Terms of Service</a>
      </div>
      <p class="powered-by">Powered by <strong>TensorLinks</strong></p>
    </mat-card-content>
    <mat-card-footer>
      <mat-progress-bar mode="indeterminate" *ngIf="requestInProgress"></mat-progress-bar>
    </mat-card-footer>
  </mat-card>
  <app-default *ngIf="!clientId || clientId === ''"></app-default>
</div>